<template>
  <div class="col-lg-12 p-0 image-input-1">
    <label class="h5 image-input-1-label" :for="inputConfig.id">{{ inputConfig.title }}</label>
    <p v-html="inputConfig.description"></p>

    <div class="custom-file image-input-1-choose-file">
      <input type="file"
             ref="general_input_1"
             accept="image/*"
             required
             @change="onImageChange"
             class="custom-file-input image-input-1-file-input" id="customFile">
      <label class="custom-file-label text-left image-input-1-file-input-label" for="customFile">انتخاب فایل</label>
    </div>

    <!-- Image preview -->
    <div v-if="imagePreview" class="mt-2 text-center form-single-image-input-1-parent">
      <img :src="imagePreview" :alt="findAttributeOnSiteInfo('site_name')[0]" class="form-single-image-input-1"/>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref} from 'vue'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default defineComponent({
  name: "ImageInput1",
  methods: {findAttributeOnSiteInfo},
  props: {
    inputConfig: Object,
    formAnswer: Object
  },
  setup(props) {
    const imagePreview = ref(null)

    const onImageChange = (event) => {
      const file = event.target.files[0]
      if (file) {
        props.formAnswer[props.inputConfig.id] = file
        const reader = new FileReader()
        reader.onload = () => {
          imagePreview.value = reader.result
        }
        reader.readAsDataURL(file)
      }
    }

    return {imagePreview, onImageChange}
  },
  mounted() {
    let defaultImage = this.inputConfig.config.image;
    if (defaultImage != null) {
      this.imagePreview = defaultImage
    }
  }
})
</script>

<style scoped>
.form-single-image-input-1 {
  max-width: 150px;
  height: auto;
}
</style>